import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  section: {
    marginTop: 16
  },
  field: {
    maxWidth: 240
  },
  warning: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 6,
    marginTop: 6,
    maxWidth: 380,
    '& .MuiSvgIcon-root': {
      width: 16,
      height: 16,
      flexShrink: 0,
      marginTop: 1
    }
  }
});
export default useStyles;